import { render, staticRenderFns } from "./update-email.vue?vue&type=template&id=6136f4c1&"
import script from "./update-email.vue?vue&type=script&lang=js&"
export * from "./update-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports